export enum BackgroundLayoutType {
  login,
  forgotPassword,
  setPassword,
  resetPassword
}
